import { UtilitiesService } from './../../core/services/utilities.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { GetAllResponse } from '../model/restful-api.model';
import { TicketRequest } from '../model/ticket-access-request.model';

@Injectable({
  providedIn: 'root'
})
export class PortalScorecardService {
  baseUrl = `${environment.portalURL}/suppliers/application/request-access/srm`;

  constructor(
    private util: UtilitiesService
  ) { }

  createRequestAccess(model) {
    return this.util.req.httpPost(this.baseUrl, model);
  }

  getRequestSupplierPortalScorecard(): Observable<GetAllResponse<TicketRequest>> {
    return this.util.req.httpGet<GetAllResponse<TicketRequest>>(this.baseUrl);
  }
}
